export const IconBarTable = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconBarTable_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconBarTable_svg__a)">
        <path d="M6.896 20.5a1 1 0 0 1-.923-1.383l1.077-2.601q.247-.611.798-.97.55-.358 1.237-.358H10.9V10.91q-4.207-.133-7.054-1.195Q1 8.653 1 7.219q0-1.54 3.218-2.63T12 3.5q4.593 0 7.796 1.09Q23 5.677 23 7.218q0 1.434-2.846 2.497T13.1 10.91v4.277h1.815q.66 0 1.224.358.564.359.811.97l1.077 2.601a1 1 0 0 1-.924 1.383h-.035a1 1 0 0 1-.924-.617l-1.064-2.57H8.92l-1.064 2.57a1 1 0 0 1-.924.617z" />
      </g>
    </svg>
  );
};
